import { LOGO, quickQuoteUrl, BASE } from "@/lib/site-core";

const solutions = [
  { label: "FUE Method", href: `${BASE}/no-shave-fue-hair-transplant/` },
  { label: "Non-Surgical", href: `${BASE}/non-surgical/` },
  { label: "For Women", href: `${BASE}/thairapy/` },
  { label: "Hair Replacement", href: `${BASE}/hair-replacement/` },
  { label: "Hair Implants", href: `${BASE}/hair-implants/` },
  { label: "Stop Hair Loss", href: `${BASE}/hair-loss/` },
];

const whyRestore = [
  { label: "Media Coverage", href: `${BASE}/media-outlet/` },
  { label: "FAQ", href: `${BASE}/hair-transplant-faqs/` },
  { label: "Blog", href: `${BASE}/hair-loss-blog/` },
  { label: "Hair Sciences Center", href: `${BASE}/hair-sciences-center/` },
];

const information = [
  { label: "Pricing", href: `${BASE}/pricing/` },
  { label: "Locations", href: `${BASE}/locations/` },
  { label: "Careers", href: `${BASE}/careers/` },
  { label: "Contact Us", href: `${BASE}/contact-us/` },
  { label: "About Us", href: `${BASE}/about-us/` },
];

const affiliatedDoctors = [
  { label: "Dr. James Harris", href: `${BASE}/doctors/dr-james-harris/`, underline: true },
  { label: "Dr. Adam Cloninger", href: `${BASE}/doctors/dr-adam-cloninger/`, underline: true },
  { label: "Dr. Shelly Lovitt", href: `${BASE}/doctors/dr-shelly-lovitt/`, underline: true },
  { label: "Dr. Shadia Saleh", href: `${BASE}/doctors/dr-shadia-saleh/`, underline: false },
  { label: "Dr. Fahad Juboori", href: `${BASE}/doctors/dr-fahad-juboori/`, underline: true },
  { label: "Dr. Broc Pratt", href: `${BASE}/doctors/dr-broc-pratt/`, underline: true },
  { label: "Dr. Anish Patel", href: "/doctors/dr-anish-patel/", underline: true },
];

const legal = [
  { label: "Terms of Use", href: `${BASE}/terms-of-use/`, underline: true },
  { label: "Cookie Policy", href: `${BASE}/cookies/`, underline: false },
  { label: "Privacy Policy", href: `${BASE}/privacy-policy/`, underline: false },
  { label: "Consumer Rights", href: `${BASE}/consumer-rights-request/`, underline: false },
  { label: "Mobile Messaging Terms", href: `${BASE}/tc-mobilesms/`, underline: false },
];

function Column({ title, links }: { title: string; links: { label: string; href: string; underline?: boolean }[] }) {
  return (
    <div>
      <h4 className="text-base font-bold text-foreground">{title}</h4>
      <ul className="mt-4 space-y-3">
        {links.map((l) => (
          <li key={l.label}>
            <a
              href={l.href}
              className="text-sm text-muted-foreground underline hover:text-primary"
            >
              {l.label}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}

export function Footer() {
  return (
    <footer className="border-t border-border bg-muted py-12">
      <div className="mx-auto max-w-7xl px-4 lg:px-8">
        <div className="grid grid-cols-2 gap-10 lg:grid-cols-6">
          <div className="col-span-2 lg:col-span-1">
            <img loading="lazy" decoding="async" src={LOGO} alt="RESTORE Hair" width={2017} height={311} className="h-8 w-auto" />
            <div className="mt-8 space-y-1 text-sm text-muted-foreground">
              <p>Restoration Holdings, LLC.</p>
              <p>(866) 488-9356</p>
              <p>Clientrelations@restorehair.com</p>
            </div>
          </div>
          <Column title="Solutions" links={solutions} />
          <Column title="Why RESTORE" links={whyRestore} />
          <Column title="Information" links={information} />
          <Column title="Affiliated Doctors" links={affiliatedDoctors} />
          <div className="col-span-2 lg:col-span-1">
            <a
              href={quickQuoteUrl}
              className="inline-block bg-primary px-8 py-4 text-sm font-bold tracking-wider text-primary-foreground transition hover:bg-primary/90"
            >
              Get A Quick Quote
            </a>
            <ul className="mt-8 space-y-2">
              {legal.map((l) => (
                <li key={l.label}>
                  <a
                    href={l.href}
                    className="text-sm text-muted-foreground underline hover:text-primary"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
            <p className="mt-6 text-xs text-muted-foreground">
              Copyright © {new Date().getFullYear()}. RestoreHair. All Rights Reserved
            </p>
          </div>
        </div>
        <p className="mt-10 text-center text-xs text-muted-foreground">
          Restoration Holdings LLC is a healthcare management company focused exclusively on hair restoration solutions, serving affiliated doctors in Chicago IL, Charlotte NC, Dallas TX, Denver CO & New York City, NY.
        </p>
      </div>
    </footer>
  );
}